import React, { useState } from "react";

interface WebsitePreviewProps {
    url: string;
    width?: string | number;
    height?: string | number;
}

const WebsitePreview: React.FC<WebsitePreviewProps> = ({
    url,
    width = "100%",
    height = 500,
}) => {
    const [iframeError, setIframeError] = useState(false);

    const screenshotUrl = `https://api.microlink.io/?url=${encodeURIComponent(
        url
    )}&screenshot=true`;

    return (
        <div style={{ width, height, border: "1px solid #ccc", overflow: "hidden" }}>
            {!iframeError ? (
                <iframe
                    src={url}
                    title="Website Preview"
                    style={{ width: "100%", height: "100%", border: "none" }}
                    onError={() => setIframeError(true)}
                />
            ) : (
                <img
                    src={screenshotUrl}
                    alt="Website Preview"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
            )}
        </div>
    );
};

export default WebsitePreview;